export const mockLeads = [
  {
    id: "lead-001",
    accidentType: "Car Accident",
    injuries: [
      { materialName: "HeadMaterial", bodyPart: "Head", injuryType: "Concussion", severity: 7 },
      { materialName: "NeckMaterial", bodyPart: "Neck", injuryType: "Whiplash", severity: 5 }
    ],
    location: { city: "Phoenix", state: "AZ" },
    estimatedValue: 15000,
    postedAt: "2026-08-11T10:30:00Z",
    contact: { firstName: "John", lastName: "D.", phone: "555-123-4567" }
  },
  {
    id: "lead-002",
    accidentType: "Truck Accident",
    injuries: [
      { materialName: "LowerBackMaterial", bodyPart: "Lower Back", injuryType: "Herniated Disc", severity: 8 },
      { materialName: "RightHipMaterial", bodyPart: "Right Hip", injuryType: "Strain", severity: 4 }
    ],
    location: { city: "Los Angeles", state: "CA" },
    estimatedValue: 25000,
    postedAt: "2026-08-10T15:45:00Z",
    contact: { firstName: "Sarah", lastName: "M.", phone: "555-234-5678" }
  },
  {
    id: "lead-003",
    accidentType: "Workplace Injury",
    injuries: [
      { materialName: "RightShoulderMaterial", bodyPart: "Right Shoulder", injuryType: "Rotator Cuff Tear", severity: 6 },
      { materialName: "RightElbowMaterial", bodyPart: "Right Elbow", injuryType: "Sprain", severity: 3 }
    ],
    location: { city: "Houston", state: "TX" },
    estimatedValue: 18000,
    postedAt: "2026-07-22T09:20:00Z",
    contact: { firstName: "Mike", lastName: "T.", phone: "555-345-6789" }
  },
  {
    id: "lead-004",
    accidentType: "Motorcycle Accident",
    injuries: [
      { materialName: "RightKneeMaterial", bodyPart: "Right Knee", injuryType: "ACL Tear", severity: 9 },
      { materialName: "RightAnkleMaterial", bodyPart: "Right Ankle", injuryType: "Fracture", severity: 7 }
    ],
    location: { city: "Chicago", state: "IL" },
    estimatedValue: 35000,
    postedAt: "2026-06-15T14:00:00Z",
    contact: { firstName: "Lisa", lastName: "K.", phone: "555-456-7890" }
  },
  {
    id: "lead-005",
    accidentType: "Slip and Fall",
    injuries: [
      { materialName: "ChestMaterial", bodyPart: "Chest", injuryType: "Rib Fracture", severity: 6 }
    ],
    location: { city: "Miami", state: "FL" },
    estimatedValue: 12000,
    postedAt: "2026-05-08T11:30:00Z",
    contact: { firstName: "David", lastName: "R.", phone: "555-567-8901" }
  },
  {
    id: "lead-006",
    accidentType: "Bicycle Accident",
    injuries: [
      { materialName: "LeftShoulderMaterial", bodyPart: "Left Shoulder", injuryType: "Dislocation", severity: 7 },
      { materialName: "LeftElbowMaterial", bodyPart: "Left Elbow", injuryType: "Fracture", severity: 5 },
      { materialName: "LeftHandMaterial", bodyPart: "Left Hand", injuryType: "Sprain", severity: 3 }
    ],
    location: { city: "Denver", state: "CO" },
    estimatedValue: 22000,
    postedAt: "2026-04-03T16:45:00Z",
    contact: { firstName: "Emma", lastName: "S.", phone: "555-678-9012" }
  },
  {
    id: "lead-007",
    accidentType: "Car Accident",
    injuries: [
      { materialName: "UpperBackMaterial", bodyPart: "Upper Back", injuryType: "Muscle Strain", severity: 4 }
    ],
    location: { city: "Seattle", state: "WA" },
    estimatedValue: 8000,
    postedAt: "2026-02-18T08:15:00Z",
    contact: { firstName: "Chris", lastName: "W.", phone: "555-789-0123" }
  },
  {
    id: "lead-008",
    accidentType: "Pedestrian Accident",
    injuries: [
      { materialName: "LeftKneeMaterial", bodyPart: "Left Knee", injuryType: "Meniscus Tear", severity: 6 },
      { materialName: "LeftThighMaterial", bodyPart: "Left Thigh", injuryType: "Contusion", severity: 4 }
    ],
    location: { city: "Atlanta", state: "GA" },
    estimatedValue: 20000,
    postedAt: "2026-01-25T13:00:00Z",
    contact: { firstName: "Jessica", lastName: "B.", phone: "555-890-1234" }
  }
];

export const injuryTypes = [
  "Concussion",
  "Whiplash",
  "Herniated Disc",
  "Strain",
  "Rotator Cuff Tear",
  "Sprain",
  "ACL Tear",
  "Fracture",
  "Rib Fracture",
  "Dislocation",
  "Muscle Strain",
  "Meniscus Tear",
  "Contusion"
];

export const states = [
  "AZ", "CA", "CO", "FL", "GA", "IL", "TX", "WA"
];

export const accidentTypes = [
  "Car Accident",
  "Truck Accident",
  "Motorcycle Accident",
  "Slip and Fall",
  "Workplace Injury",
  "Medical Malpractice",
  "Dog Bite",
  "Pedestrian Accident",
  "Bicycle Accident",
  "Product Liability"
];

export const accidentImages = {
  "Car Accident": "/images/accidents/car-accident.jpg",
  "Truck Accident": "/images/accidents/truck-accident.jpg",
  "Motorcycle Accident": "/images/accidents/motorcycle-accident.jpg",
  "Slip and Fall": "/images/accidents/slip-fall.jpg",
  "Workplace Injury": "/images/accidents/workplace-injury.jpg",
  "Medical Malpractice": "/images/accidents/medical.jpg",
  "Dog Bite": "/images/accidents/dog-bite.jpg",
  "Pedestrian Accident": "/images/accidents/pedestrian.jpg",
  "Bicycle Accident": "/images/accidents/bicycle-accident.jpg",
  "Product Liability": "/images/accidents/product-liability.jpg"
};
